import { useEffect, useState } from "react";
import { CloudOff } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/lib/i18n";
import { flushDrops, pendingCount, stuckCount } from "@/lib/offline";

export function OfflineSync() {
  const { user } = useAuth();
  const t = useT();
  const [n, setN] = useState(pendingCount);
  const [stuck, setStuck] = useState(stuckCount);
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const sync = () => { setN(pendingCount()); setStuck(stuckCount()); };
    const up = () => { setOnline(true); if (user) flushDrops(); };
    const down = () => setOnline(false);
    window.addEventListener("pending-drops", sync);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    if (user) flushDrops();
    const id = setInterval(() => { if (user && navigator.onLine) flushDrops(); }, 30000);
    return () => { window.removeEventListener("pending-drops", sync); window.removeEventListener("online", up); window.removeEventListener("offline", down); clearInterval(id); };
  }, [user]);

  if (online && !n && !stuck) return null;
  return (
    <div className="offline-bar" data-testid="offline-bar">
      <CloudOff size={14} />
      {!online ? t("No signal. The calculator still works.") : null}
      {n > 0 && <span data-testid="offline-pending"> {t("{n} drop(s) waiting to upload", { n })}</span>}
      {stuck > 0 && <span data-testid="offline-stuck"> {t("{n} drop(s) couldn't upload and are kept on this phone. Tap Help to ask the developer.", { n: stuck })}</span>}
    </div>
  );
}
